<template>
  <div>
    <div
      v-if="loading"
      class="h-64 p-32 flex justify-center items-center"
    >
      <vue-element-loading
        :active="loading"
        spinner="spinner"
        color="#DBDBDB"
        background-color="rgba(255, 255, 255, .5)"
      />
    </div>
    <div v-else>
      <div
        class="container px-6 mt-4"
        v-if="answers_user.about_you"
      >
        <h1 class="uppercase text-lg pl-0 md:pl-6 font-bold"><span class="text-pink-500">2.</span> {{ $t('messages.general.description') }}</h1>
        <div
          class="flex mt-6 flex-wrap"
          v-for="(item,i) in answers_user.about_you.subcategories"
          :key="i"
        >
          <h1 class="uppercase text-lg text-blue-500 mt-6 pl-0 md:pl-6 font-bold w-full">{{ item.name[locale] }}</h1>
          <template v-for="question in item.questions">
            <question-profile
              :question="question.title"
              :typeQuestion="question.type_question"
              :placeholder="question.placeholder"
              :questionOption="question.options"
              :answer="question.answer"
              :vvScope="vvScope"
              :validations="{
                required: question.required === 1,
                min_words: question.type_question.name === 'textarea' ? 25 : 0,
                max_words: question.type_question.name === 'textarea' ? 500 : 500
              }"
              :name="question.title"
              :width="question.width"
              :key="question.id"
              :id="question.id"
            >
            </question-profile>
          </template>
        </div>
      </div>

      <div
        class="container px-6 mt-16"
        v-if="answers_user.spiritual_qualities"
      >
        <div
          class="flex mt-6 flex-wrap"
          v-for="(item,i) in answers_user.spiritual_qualities.subcategories"
          :key="i"
        >
          <h1 class="uppercase text-lg text-blue-500 mt-6 pl-0 md:pl-6 font-bold w-full">{{ item.name[locale] }}</h1>
          <template v-for="question in item.questions">
            <question-profile
              v-if="question.id === 43 ||question.id === 48 || question.id === 42 || question.id === 131 ||question.id === 44 ||question.id === 46 ||question.id === 47"
              :question="question.title"
              :typeQuestion="question.type_question"
              :placeholder="question.placeholder"
              :questionOption="question.options"
              :answer="question.answer"
              :vvScope="vvScope"
              :validations="{
                required: question.required === 1,
                min_words: question.type_question.name === 'textarea' ? 25 : 0,
                max_words: question.type_question.name === 'textarea' ? 500 : 500
              }"
              :name="question.title"
              :width="question.width"
              :key="question.id"
              :id="question.id"
            >
            </question-profile>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QuestionProfile from "@/components/QuestionProfile.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import _ from 'lodash';

export default {
  name: "StepTwo",
  componets: {
    QuestionProfile
  },
  props: ["clickedNext", "currentStep", "loading"],
  mixins: [validationMixin],
  data() {
    return {
      vvScope: "step2",
      form: {
        profile: ""
      },
      filtered_spiritual_goals: {}
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("answers", ["answers_user"]),
    ...mapState("locale", ["locale"])
  },
  async created() {
    await this.showAnswer();
  },
  methods: {
    ...mapActions("auth", ["fetchUser"]),
    ...mapActions("answers", ["showAnswersUsers"]),
    async showAnswer() {
      await this.showAnswersUsers(this.user.id);
    }
  }
};
</script>
